import { Button, Box } from '@mui/material';
import { stringValidation } from 'src/services/validation';
import { string, object } from 'yup';
import FormWrapper from 'src/components/FormWrapper';
import ExemptionFormFields from 'src/components/ExemptionFormFields';
import AuthContext from 'src/store/auth-context';
import { useContext } from 'react';
const exemptionSchema = object().shape({
  multipleAccts: stringValidation(),
  associatedAcctInfo: string().when('multipleAccts', {
    is: 'Y',
    then: stringValidation(),
    otherwise: string(),
  }),
  ownerChg: stringValidation(),
  reqExempt: stringValidation(),
  busStatus: string().when('ownerChg', {
    is: 'Y',
    then: string()
      .required()
      .matches(/(sold)/),
    otherwise: string(),
  }),
});

const ExemptionForm = ({ onClose = () => {}, onSubmit = () => {}, SecondaryBtn, values }) => {
  const { backdoor } = useContext(AuthContext);

  return (
    <>
      <FormWrapper
        onSubmit={onSubmit}
        validationSchema={exemptionSchema}
        initialValues={values}
        enableReinitialize
      >
        <ExemptionFormFields />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            mt: '0.50rem',
            ml: '0.125rem',
          }}
        >
          <Button type="button" variant="outlined" onClick={onClose} sx={{ mr: '0.5rem' }}>
            Cancel
          </Button>
          {SecondaryBtn}
          <Button
            data-cy="submit"
            type="submit"
            variant="contained"
            disabled={backdoor}
            sx={{ ml: '0.5rem' }}
          >
            Request
          </Button>
        </Box>
      </FormWrapper>
    </>
  );
};

export default ExemptionForm;
